import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDownIcon } from 'src/assets/icons/ChevronDownIcon';
import { NESTED_AND_EXTERNAL_ROUTE_ICON_KEY_MAP, RouteIconKeys, ROUTE_ICONS } from 'src/constants';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { StyledListItem, StyledAccordion, StyledNavLinkLabel, StyledNavLinkIcon } from './Links.styled';

export interface CollapsibleLinkItemProps {
  children?: React.ReactNode;
  label: string;
  $menuIsOpen: boolean;
  icon_key?: RouteIconKeys;
}

export const CollapsibleLinkItem: React.FunctionComponent<CollapsibleLinkItemProps> = ({
  children = undefined,
  label,
  $menuIsOpen,
  icon_key = NESTED_AND_EXTERNAL_ROUTE_ICON_KEY_MAP.OTHERS,
}) => {
  const { t } = useTranslation();

  const Icon = ROUTE_ICONS[icon_key];
  return (
    <StyledListItem>
      <StyledAccordion $menuIsOpen={$menuIsOpen}>
        <AccordionSummary expandIcon={<ChevronDownIcon />}>
          {Icon ? (
            <StyledNavLinkIcon>
              <Icon />
            </StyledNavLinkIcon>
          ) : null}
          <StyledNavLinkLabel $menuIsOpen={$menuIsOpen}>{t(label)}</StyledNavLinkLabel>
        </AccordionSummary>
        <AccordionDetails>{children}</AccordionDetails>
      </StyledAccordion>
    </StyledListItem>
  );
};
